export enum SocialLoginProvider {
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  APPLE = 'apple',
}

export enum SocialLoginProviderId {
  GOOGLE_ID = 'google.com',
  MICROSOFT_ID = 'microsoft.com',
  APPLE_ID = 'apple.com',
}
